import { Injectable } from '@angular/core';
import { ApiResponse } from '@src/app/core/models/api-response.model';
import { ApiWebSubmissionService } from '@src/app/core/services/api-web-submission.service';
import { Observable } from 'rxjs';
import { OcrResp } from '../model/ocrResp';

@Injectable({
  providedIn: 'root',
})
export class OCRService {
  constructor(private apiWebSubmissionService: ApiWebSubmissionService) {}


  GetOCRRecord(params: {
    submissionNo: number;
  }): Observable<ApiResponse<OcrResp>> {
    return this.apiWebSubmissionService.doGet(
      `/Submission/OCR/${params.submissionNo}`
    );
  }
}
